import OnboardingTile from './OnboardingTile';

export default OnboardingTile;
